module.exports = __webpack_public_path__ + "img/icon-objectives.e7047a57.svg";